import React from 'react';
import { gu2px, useTheme, Colorway } from '@uds/theme-utils';
import { useStyles } from '@team-griffin/stylr';

import PaginationItem from './PaginationItem';

interface OuterProps {
  itemCount: number;
  activeIndex: number;
  colorway: Colorway;
  visibleItems: number;
}

const useStylesheet = () => {
  const {
    theme: { spacing },
  } = useTheme();
  return useStyles({
    default: {
      root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: gu2px(1, spacing),
      },
    },
  });
};

declare const i: number;

const PureSalesboardPagination = ({ itemCount, activeIndex, visibleItems, colorway }: OuterProps) => {
  const { styles } = useStylesheet();
  return (
    <div style={styles.root}>
      <For each="item" of={new Array(itemCount).fill(0)} index="i">
        <PaginationItem
          colorway={colorway}
          role="button"
          key={`item_${i}`}
          activeIndex={activeIndex}
          visibleItems={visibleItems}
          index={i}
        />
      </For>
    </div>
  );
};

PureSalesboardPagination.displayName = 'SalesboardPagination';

export default PureSalesboardPagination;
